import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
var _excluded = ["alt", "className", "loading", "src", "srcTwoX", "forceTwoXInSrc", "transformations", "width", "height", "style"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.string.trim.js";
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import { useContext } from 'react';
import Utility from "../../Utility/Utility";
import { RetinaContext } from "../../../context/retina.context";
import { jsx as _jsx } from "react/jsx-runtime";
export var Image = function Image(_ref) {
  var _ref$alt = _ref.alt,
    alt = _ref$alt === void 0 ? '' : _ref$alt,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$loading = _ref.loading,
    loading = _ref$loading === void 0 ? 'lazy' : _ref$loading,
    src = _ref.src,
    _ref$srcTwoX = _ref.srcTwoX,
    srcTwoX = _ref$srcTwoX === void 0 ? '' : _ref$srcTwoX,
    _ref$forceTwoXInSrc = _ref.forceTwoXInSrc,
    forceTwoXInSrc = _ref$forceTwoXInSrc === void 0 ? false : _ref$forceTwoXInSrc,
    transformations = _ref.transformations,
    width = _ref.width,
    height = _ref.height,
    style = _ref.style,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var retinaEnabled = useContext(RetinaContext);
  var transformations1x = transformations ? transformations.image1x : undefined;
  var transformations2x = transformations ? transformations.image2x : undefined;
  var image1x = Utility.getOptimizedCloudinaryUrl(src, forceTwoXInSrc ? transformations2x : transformations1x);
  var image2x = Utility.getOptimizedCloudinaryUrl(forceTwoXInSrc ? '' : srcTwoX || src, transformations2x);
  var srcset = retinaEnabled && !forceTwoXInSrc && image2x && image2x !== image1x ? "".concat(image1x, ", ").concat(image2x, " 2x") : undefined;
  var imgWidth = width ? width : undefined;
  var imgHeight = srcset ? undefined : height;

  // Sanitize alt text, if any.
  var altText = "".concat(alt) || '';
  if (altText.trim() === '""' || altText === 'null' || altText === 'undefined') {
    altText = '';
  }
  altText = Utility.escapeHTML(altText);
  return /*#__PURE__*/_jsx("img", _objectSpread({
    src: image1x,
    srcSet: srcset,
    width: imgWidth,
    height: imgHeight,
    alt: altText,
    className: className,
    loading: loading,
    style: style
  }, otherProps));
};